<template>
  <img v-if="upwards === true && color === 'green'" src="@/assets/arrow_up_green.svg">
  <img v-else-if="upwards === true && color === 'red'" src="@/assets/arrow_up_red.svg">
  <img v-else-if="upwards === false && color === 'green'" src="@/assets/arrow_down_green.svg">
  <img v-else-if="upwards === false && color === 'red'" src="@/assets/arrow_down_red.svg">
</template>

<script>
export default {
  name: 'MetricIcon',
  props: ['upwards', 'color']
}
</script>
